<template>
    <UsuarioComponent/>
</template>
<script>
import UsuarioComponent from "@/components/UsuarioComponent.vue";
export default { components: { UsuarioComponent } };
</script>

<style>
</style>